import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService, User } from '@auth0/auth0-angular';
import { NgxRolesService } from 'ngx-permissions';
import { firstValueFrom } from 'rxjs';
import { Menu, MenuService } from './menu.service';

export const MENU: Menu[] = [
  {
    route: 'dashboard',
    name: 'dashboard',
    type: 'link',
    icon: 'dashboard',
  },
  {
    route: 'campaign',
    name: 'campaign',
    type: 'link',
    icon: 'campaign',
  },
];

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  private readonly _authService = inject(AuthService);
  private readonly _menuService = inject(MenuService);
  private readonly _rolesService = inject(NgxRolesService);
  private readonly _title = inject(Title);

  // private readonly _rolesKey = 'userRoles';
  private readonly _permissionKey = 'userRoles';

  async load(): Promise<void> {
    try {
      const user = await firstValueFrom(this._authService.user$);
      // this._setPermissions(user);
      this._setMenu(MENU);
      this._setTitle(user);
    } catch (error) {
      throw new Error('Error during startup');
    }
  }

  private _setMenu(menu: Menu[]): void {
    this._menuService.addNamespace(menu, 'menu');
    this._menuService.set(menu);
  }

  private _setPermissions(user: User | null | undefined): void {
    if (user) {
      const permissions = user[this._permissionKey] as {
        [name: string]: string[];
      };
      if (permissions) {
        this._rolesService.addRolesWithPermissions(permissions);
      }
    }
  }

  private _setTitle(user: User | null | undefined): void {
    if (user?.['org_name']) {
      this._title.setTitle(`${user['org_name']} - Re:Engage`);
    }
  }
}
